module.exports = __webpack_public_path__ + "img/033-agenda.4f249aa2.svg";